import imgVoiceovers from '../assets/home/voiceovers.jpg';
import imgDubbing from '../assets/home/dubbing-thumb.jpg';
import imgClone from '../assets/home/clone.jpg';
import imgMusic from '../assets/home/music.jpg';
import { C } from '../styles/tokens';

// `label` matches the keys in Dashboard's CARD_PATHS so navigation stays wired.
// `tool` is the canonical analytics key for the tile (stable across label copy changes);
// it feeds the `tool` prop on the Dashboard - Tool Clicked event.
const CARDS = [
  { label: 'AI Voiceover',    sub: 'Text to speech',      img: imgVoiceovers, tool: 'ai_voiceover' },
  { label: 'Dubbing',         sub: '30+ languages',        img: imgDubbing,    tool: 'dubbing' },
  { label: 'Voice Cloning',   sub: 'Clone your voice',     img: imgClone,      tool: 'voice_cloning' },
  { label: 'Music Generator', sub: 'AI background music',  img: imgMusic,      tool: 'music_generator' },
];

export default function ShortcutTiles({ onCardClick }) {
  return (
    <>
      <style>{`
        .l2i-hero-card { transform-origin:center; }
        .l2i-hero-card:hover .l2i-hero-imgwrap {
          box-shadow: 0 10px 24px rgba(15,23,42,.12);
          transform: translateY(-2px);
        }
        .l2i-hero-card:hover .l2i-hero-veil { opacity: 1; }
        .l2i-hero-card:hover .l2i-hero-go { opacity: 1; transform: translateY(0); }
        .l2i-hero-card:hover .l2i-hero-title { color: ${C.p600}; }
        @media (prefers-reduced-motion: reduce) {
          .l2i-hero-card:hover .l2i-hero-imgwrap { box-shadow:none; transform:none; }
          .l2i-hero-card:hover .l2i-hero-go { transform:none; }
        }
        .l2i-shortcut-grid {
          display: grid;
          grid-template-columns: repeat(${CARDS.length}, 1fr);
          gap: 18px;
        }
        @media (max-width: 860px) {
          .l2i-shortcut-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
        }
      `}</style>

      <div className="l2i-shortcut-grid">
        {CARDS.map((card, i) => (
          <button key={i} onClick={() => onCardClick?.(card)} className="l2i-hero-card"
            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left', position: 'relative', minWidth: 0 }}>
            <div className="l2i-hero-imgwrap" style={{
              position: 'relative', width: '100%', aspectRatio: '16 / 10',
              borderRadius: 16, overflow: 'hidden',
              background: C.n100, boxShadow: '0 1px 3px rgba(15,23,42,.06)',
              isolation: 'isolate',
              transition: 'box-shadow .25s cubic-bezier(.2,.7,.3,1), transform .25s cubic-bezier(.2,.7,.3,1)',
            }}>
              <img src={card.img} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              <span className="l2i-hero-veil" style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 55%, rgba(15,23,42,.28) 100%)', opacity: 0, transition: 'opacity .25s', pointerEvents: 'none' }} />
              <span className="l2i-hero-go" style={{
                position: 'absolute', right: 10, bottom: 10, width: 32, height: 32, borderRadius: '50%',
                background: 'rgba(255,255,255,.92)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(15,23,42,.18)',
                opacity: 0, transform: 'translateY(6px)', transition: 'opacity .25s, transform .25s cubic-bezier(.2,.7,.3,1)',
                pointerEvents: 'none',
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={C.n900} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </span>
            </div>
            <div style={{ padding: '10px 2px 0' }}>
              <div className="l2i-hero-title" style={{ fontSize: 15.5, fontWeight: 700, color: C.n900, letterSpacing: '-.01em', transition: 'color .2s' }}>{card.label}</div>
              <div style={{ fontSize: 12.5, color: C.n500, marginTop: 2 }}>{card.sub}</div>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
